// src/instrumentation-client.ts
// Runs before React hydrates: keeps Chrome's page translator from crashing the app.
import { installDomMutationGuard } from "@/lib/translation/dom-mutation-guard";
import { watchRouteAnnouncer } from "@/lib/translation/route-announcer";

installDomMutationGuard(Node.prototype, (message) => console.error(message));
watchRouteAnnouncer(document);
